import { ChangeIsProductSelected } from '../../../Services/BasketService'
import { useConfig } from '../../../Providers/ConfigProvider'
import { useAuth } from '../../../Providers/AuthProvider'
import { useCart } from '../../../Providers/CartProvider'

const useChangeIsProductSelected = () => {
    const { api } = useConfig()
    const { authState } = useAuth()
    const { setCartItems } = useCart()

    const handleChangeIsProductSelected = async (artNo, isSelected) => {
        try {
            const res = await ChangeIsProductSelected(api, artNo, authState.custId, authState.user.userId, isSelected)
            setCartItems(prev => ({
                ...prev,
                basketItems: prev.basketItems.map(item =>
                    item.artNo === artNo ? { ...item, isSelected: isSelected } : item
                )
            }))
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }

    return { handleChangeIsProductSelected }
}

export default useChangeIsProductSelected